import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { LicenseManager } from 'ag-grid-enterprise';
import { AppModule } from './app/app.module';
import { ENVIRONMENT } from './environments/environment';

const key = `Using_this_{AG_Grid}_Enterprise_key_{AG-078555}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Schweizerische_Bundesbahnen_SBB_Cargo_AG}_is_granted_a_{Multiple_Applications}_Developer_License_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{2_May_2026}____[v3]_[01]_MTc3NzY3NjQwMDAwMA==1c1f317eea762de2f65590dff6175d63`;

LicenseManager.setLicenseKey(key);

if (ENVIRONMENT.production) {
  enableProdMode();
}

if (window) {

  const error = window.console.error;

  window.console.error = function (message: string) {
    const errorMessages = [`ag-Grid: unable to find bean reference`];

    if (!message.includes || !errorMessages.find(o => message.includes(o))) {
      error.apply(window.console, arguments);
    } else if (!ENVIRONMENT.production) {
      // window.console.log(`Console error filtered in main.ts: ${message}`);
    }
  };
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));

